const dragNDropStyle = theme => ({
    main: {
        marginTop: "0px"
    },
    
});

export default dragNDropStyle;
